module.exports = __webpack_public_path__ + "static/media/hero-boy.c43b3a15.webp";